

























































import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import TournamentBasicInformation from '@/modules/tournament/components/TournamentBasicInformation'
import { TournamentAction } from '@/modules/tournament/components/TournamentBasicInformation/TournamentBasicInformation.vue'
import {
  MemberJoinedTournamentsEntity,
  TournamentEntity,
  TournamentState
} from '@/api/tournament'
import gsap, { Power2 } from 'gsap'
import { unixTimestampToDateTime } from '@/utils'

@Component({
  components: {
    TournamentBasicInformation
  }
})
export default class FeaturedTournament extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)
  isHover: boolean = false
  isLogoVisible: boolean = true
  isBannerError: boolean = false

  @Prop({ required: true }) readonly tournament!: TournamentEntity
  @Prop({ required: false }) readonly animating!: boolean
  @Prop({ required: true }) readonly index!: string
  @Prop({ default: 25 }) readonly width!: number

  /* Vuex State */
  get joinedTournaments(): MemberJoinedTournamentsEntity[] {
    return this.tournamentModule.joinedTournaments
  }

  get regStartTime() {
    if (!this.tournament || !this.tournament.scheduleRegistrationStartTime)
      return 0

    return this.tournament.scheduleRegistrationStartTime
  }

  get regEndTime() {
    if (!this.tournament || !this.tournament.scheduleRegistrationEndTime)
      return 0

    return this.tournament.scheduleRegistrationEndTime
  }

  get scheduleStartTime() {
    if (!this.tournament || !this.tournament.scheduleStartTime) return 0

    return this.tournament.scheduleStartTime
  }

  get scheduleEndTime() {
    if (!this.tournament || !this.tournament.scheduleEndTime) return 0

    return this.tournament.scheduleEndTime
  }

  unixToTime(value: number) {
    return unixTimestampToDateTime(value)
  }

  /* Computed Properties */
  get bannerSrc() {
    if (
      !this.tournament ||
      !this.tournament.detailBanner ||
      this.isBannerError
    ) {
      return require('@/assets/default/tournament_background.png')
    }
    return this.$vuetify.breakpoint.mobile
      ? this.tournament.detailMobileBanner
      : this.tournament.detailBanner
  }

  get hasJoinedTournament(): boolean {
    return this.joinedTournaments
      .map(tournament => tournament.tournamentId)
      .includes(this.tournament.tournamentId)
  }

  get tournamentAction(): TournamentAction {
    if (
      this.hasJoinedTournament ||
      !this.tournament ||
      this.tournament.state !== TournamentState.OpenRegistration
    ) {
      return TournamentAction.ViewTournament
    }
    return TournamentAction.JoinTournament
  }

  get cssRules() {
    return {
      '--width': this.width + '%'
    }
  }

  /* Methods */
  onTournamentMouseOver() {
    this.isHover = true

    gsap
      .to('.tournament-logo-' + this.index, {
        opacity: 0,
        top: 0,
        duration: 0.3,
        scale: 0.8
      })
      .eventCallback('onComplete', () => {
        this.isLogoVisible = false
      })
  }

  onTournamentMouseLeave() {
    this.isHover = false
    this.isLogoVisible = true

    gsap
      .to('.tournament-logo-' + this.index, {
        opacity: 1,
        top: 'auto',
        bottom: 0,
        duration: 0.3,
        scale: 0.6
      })
      .eventCallback('onComplete', () => {
        this.isLogoVisible = true
      })
  }

  /* Emitter */
  @Emit('select')
  onTournamentSelected() {
    return this
  }
}
